import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectModule } from 'primeng/select';
import { filter, Subject, takeUntil } from 'rxjs';
import { RootState } from '../../../../../store/reducers/RootState.model';
import { PSLActions } from '../../../../../store/workflow/actions/user-profile.actions';
import {
  selectDropdownPSLs,
  selectPSL,
} from '../../../../../store/workflow/selectors/user-profile.selectors';
import { selectRelatedVDRJob } from '../../../../../store/workflow/selectors/workflow.selectors';
import { PSLItem } from '../../../../models/master-data/psl';

@Component({
  selector: 'app-psl-selection',
  imports: [SelectModule, FormsModule, ButtonModule, AsyncPipe],
  templateUrl: './psl-selection.component.html',
  styleUrl: './psl-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PslSelectionComponent implements OnInit, OnDestroy {
  #store = inject(Store<RootState>);
  #destroy$ = new Subject<void>();

  pslDatasource$ = this.#store.select(selectDropdownPSLs);
  vdrJob$ = this.#store.select(selectRelatedVDRJob);
  previousPSLId: string = '';

  pslDatasource = toSignal(this.#store.select(selectDropdownPSLs));

  private _currentPSL: WritableSignal<PSLItem | undefined> = signal(undefined);
  get currentPSL() {
    return this._currentPSL()!;
  }

  set currentPSL(value: PSLItem) {
    this._currentPSL.set(value);
  }

  title = 'PSL Selection';

  constructor(private dialogRef: DynamicDialogRef) {}

  ngOnInit() {
    this.#store.dispatch(PSLActions.getAvailablePSLs());

    this.loadPSLData();
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  loadPSLData() {
    this.#store
      .select(selectPSL)
      .pipe(
        filter((psl) => !!psl),
        takeUntil(this.#destroy$),
      )
      .subscribe((psl) => {
        this.currentPSL = {
          name: psl.name,
          id: psl.id,
          code: psl.code || '',
        } as PSLItem;
        this.previousPSLId = psl.id;
      });
  }

  selectItem(): void {
    if (this.currentPSL) {
      this.dialogRef.close(this.currentPSL);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
